module.exports = __webpack_public_path__ + "static/media/external_env_2_media_3.26a57ac5.webp";